import React, { lazy, Suspense, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
    SecondAds,
    FirstAds,
    MobileUnderCalAds
} from "../../Ads";
import SharedHelmet from "../Helmet";
const BodyFatTable = lazy(() => import("./BodyFatTable"));
const TITLE = 'Calcul du pourcentage de graisse corporelle';
const DESCRIPTION =
  "Calcul du pourcentage de graisse corporelle en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "calcul du pourcentage de graisse corporelle, calculatrice calcul du pourcentage de graisse corporelle, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = 'https://do-calculate.com/calculator/fr/bodyfat/';
function BodyFatCalculator() {
    const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [age, setAge] = useState("");
    const [gender, setGender] = useState("");
    const [neckMeasurement, setNeckMeasurement] = useState("");
    const [waistMeasurement, setWaistMeasurement] = useState("");
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const calculateBodyFatLocal = (weight, waistMeasurement, neckMeasurement, height, age, gender) => {
        try {
            const weightInches = weight * 0.393701;
            const waistInches = waistMeasurement * 0.393701;
            const neckInches = neckMeasurement * 0.393701;
            const heightInches = height * 0.393701;
            let bodyFatPercentage;
            if (gender.toLowerCase() === 'male') {
                bodyFatPercentage = (86.010 * Math.log10(waistInches - neckInches)) - (70.041 * Math.log10(heightInches)) + 36.76;
                bodyFatPercentage = bodyFatPercentage.toFixed(2);
                if (age >= 40) {
                    bodyFatPercentage = parseFloat(bodyFatPercentage) + 0.5;
                }
            } else if (gender.toLowerCase() === 'female') {
                bodyFatPercentage = (163.205 * Math.log10(waistInches + waistInches - neckInches)) - (97.684 * Math.log10(heightInches)) - 78.387;
                bodyFatPercentage = bodyFatPercentage.toFixed(2);
                if (age >= 40) {
                    bodyFatPercentage = parseFloat(bodyFatPercentage) + 0.5;
                }
            } else {
                throw new Error('Sexe invalide. Seuls "male" et "female" sont autorisés.');
            }
            let bodyFatCategory = null;
            if (gender.toLowerCase() === 'male') {
                if (bodyFatPercentage < 2) {
                    bodyFatCategory = 'Moins que la graisse essentielle';
                    bodyFatPercentage = 0;
                } else if (bodyFatPercentage >= 2 && bodyFatPercentage <= 5) {
                    bodyFatCategory = 'Graisse essentielle';
                } else if (bodyFatPercentage > 5 && bodyFatPercentage <= 13) {
                    bodyFatCategory = 'Athlètes';
                } else if (bodyFatPercentage > 13 && bodyFatPercentage <= 17) {
                    bodyFatCategory = 'Forme physique';
                } else if (bodyFatPercentage > 17 && bodyFatPercentage <= 25) {
                    bodyFatCategory = 'Acceptable';
                } else if (bodyFatPercentage > 25) {
                    bodyFatCategory = 'Obésité';
                }
            } else if (gender.toLowerCase() === 'female') {
                if (bodyFatPercentage >= 10 && bodyFatPercentage <= 13) {
                    bodyFatCategory = 'Graisse essentielle';
                } else if (bodyFatPercentage > 13 && bodyFatPercentage <= 20) {
                    bodyFatCategory = 'Athlètes';
                } else if (bodyFatPercentage > 20 && bodyFatPercentage <= 24) {
                    bodyFatCategory = 'Forme physique';
                } else if (bodyFatPercentage > 24 && bodyFatPercentage <= 32) {
                    bodyFatCategory = 'Acceptable';
                } else if (bodyFatPercentage > 32) {
                    bodyFatCategory = 'Obésité';
                }
            }
            if (bodyFatCategory === null) {
                throw new Error('Impossible de déterminer la catégorie de graisse corporelle.');
            }
            const fatMass = ((bodyFatPercentage / 100) * weight).toFixed(2);
            const leanMass = (weight - fatMass).toFixed(2);
            let idealBodyFatPercentage = 0;
            if (gender.toLowerCase() === 'male') {
                if (age >= 20 && age < 25) {
                    idealBodyFatPercentage = 8.5;
                } else if (age >= 25 && age < 30) {
                    idealBodyFatPercentage = 10.5;
                } else if (age >= 30 && age < 35) {
                    idealBodyFatPercentage = 12.7;
                } else if (age >= 35 && age < 40) {
                    idealBodyFatPercentage = 13.7;
                } else if (age >= 40 && age < 45) {
                    idealBodyFatPercentage = 15.3;
                } else if (age >= 45 && age < 50) {
                    idealBodyFatPercentage = 16.4;
                } else if (age >= 50 && age < 55) {
                    idealBodyFatPercentage = 18.9;
                } else if (age >= 55) {
                    idealBodyFatPercentage = 20.9;
                }
            } else if (gender.toLowerCase() === 'female') {
                if (age >= 20 && age < 25) {
                    idealBodyFatPercentage = 17.7;
                } else if (age >= 25 && age < 30) {
                    idealBodyFatPercentage = 18.4;
                } else if (age >= 30 && age < 35) {
                    idealBodyFatPercentage = 19.3;
                } else if (age >= 35 && age < 40) {
                    idealBodyFatPercentage = 21.5;
                } else if (age >= 40 && age < 45) {
                    idealBodyFatPercentage = 22.2;
                } else if (age >= 45 && age < 50) {
                    idealBodyFatPercentage = 22.9;
                } else if (age >= 50 && age < 55) {
                    idealBodyFatPercentage = 25.2;
                } else if (age >= 55) {
                    idealBodyFatPercentage = 26.3;
                }
            }
            let bodyFatToLose = 0;
            if (age >= 20) {
                bodyFatToLose = ((bodyFatPercentage - idealBodyFatPercentage) / 100 * weight).toFixed(2);
            }
            const result = {
                bodyFatPercentage,
                fatMass,
                leanMass,
                bodyFatCategory,
                idealBodyFatPercentage,
                bodyFatToLose
            };
            return { result };
        } catch (error) {
            throw error;
        }
    };
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleNeckMeasurementChange = (event) => {
        setNeckMeasurement(event.target.value);
    };
    const handleWaistMeasurementChange = (event) => {
        setWaistMeasurement(event.target.value);
    };
    const calculateBodyFat = () => {
        setIsLoading(true);
        setError(null);
        setStatusCode(null);
        try {
            if (!weight || !height || !age || !gender || !neckMeasurement || !waistMeasurement) {
                setError("Veuillez saisir tous les champs correctement.");
                setStatusCode(400);
                setResult(null);
                return;
            }
            const weightNum = parseFloat(weight);
            const heightNum = parseFloat(height);
            const ageNum = parseInt(age);
            const neckNum = parseFloat(neckMeasurement);
            const waistNum = parseFloat(waistMeasurement);
            if (isNaN(weightNum) || isNaN(heightNum) || isNaN(ageNum) || isNaN(neckNum) || isNaN(waistNum)) {
                setError("Veuillez saisir des valeurs numériques valides.");
                setStatusCode(400);
                setResult(null);
                return;
            }
            const calculationResult = calculateBodyFatLocal(
                weightNum,
                waistNum,
                neckNum,
                heightNum,
                ageNum,
                gender
            );
            setResult(calculationResult.result);
            setClassification(calculationResult.result.bodyFatCategory);
            setStatusCode(200);
        } catch (error) {
            console.error(error);
            setError("Une erreur s'est produite lors du calcul. Veuillez vérifier les données saisies.");
            setStatusCode(400);
            setResult(null);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white  text-center  justify-content-center align-items-center" style={{ height: '35px' }}>
                        <h1 style={{ fontSize: '16px' }}>Calcul du pourcentage de graisse corporelle pour les hommes et les femmes</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                La calculatrice de pourcentage de graisse calcule le pourcentage de graisse corporelle et calcule le pourcentage de graisse corporelle normal pour les hommes et les femmes et le pourcentage normal de triglycérides, qui est le pourcentage du poids corporel total qui représente la graisse.
                                <br />
                                La calculatrice de pourcentage de graisse corporelle vous permet de calculer et de mesurer le pourcentage de graisse corporelle en utilisant différentes équations telles que l'équation de Jackson et Pollard. La calculatrice de pourcentage de graisse corporelle est importante pour estimer la santé d'une personne et son niveau de forme physique.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Pourcentage de graisse corporelle
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='height' className="form-label ms-2" >Taille</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="height"
                                        value={height}
                                        onChange={handleHeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '100%' }}
                                        placeholder="175"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='weightNumber' className="form-label ms-2">Poids</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                        placeholder="65"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">kg</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='age' className="form-label ms-2">Âge</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="age"
                                        value={age}
                                        onChange={handleAgeChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="33"
                                        min="2"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Sexe</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            id="male"
                                            checked={gender === "male"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label htmlFor="male" className="form-check-label">
                                            Homme
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            id="female"
                                            checked={gender === "female"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label htmlFor="female" className="form-check-label">
                                            Femme
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='neck' className="form-label ms-2">Tour de cou</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="neck"
                                        value={neckMeasurement}
                                        onChange={handleNeckMeasurementChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                        placeholder="38"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='waist' className="form-label ms-2">Tour de taille</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="waist"
                                        value={waistMeasurement}
                                        onChange={handleWaistMeasurementChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                        placeholder="85"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <button
                                    className="btn btn-success"
                                    style={{ fontSize: "20px" }}
                                    onClick={calculateBodyFat}
                                >
                                    Calculer
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                {result && (
                                    <div>
                                        <div className="alert alert-success">
                                            <h5>Résultats :</h5>
                                            <p>Pourcentage de graisse corporelle: {result.bodyFatPercentage}%</p>
                                            <p>Masse grasse: {result.fatMass} kg</p>
                                            <p>Masse maigre: {result.leanMass} kg</p>
                                            <p>Catégorie: {result.bodyFatCategory}</p>
                                            <p>Pourcentage de graisse idéal: {result.idealBodyFatPercentage}%</p>
                                            <p>Graisse à perdre: {result.bodyFatToLose} kg</p>
                                        </div>
                                    </div>
                                )}
                                {error && (
                                    <div className="alert alert-danger">
                                        <h5>Erreur :</h5>
                                        {error}
                                    </div>
                                )}
                                {isLoading && (
                                    <div className="alert alert-info">
                                        Calcul en cours...
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <RelatedLinks />
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList></MainCalculatorsList>
                    <br />
                </div>
            </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce que le pourcentage de graisse corporelle ?</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Valeurs de rfrence</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodyFatCalculator;
